import { Input, Segmented } from "antd";
import { useCallback, useEffect, useMemo, useState } from "react";
import "./queryList.css";
import search from "../../assets/icons/ModelSearch.svg";
import deleteIcon from "../../assets/icons/Delete-transparent.svg";
import selectIcon from "../../assets/icons/select-all.svg";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import QueryTab from "./queryTab";
import GenerateQuery from "./generateQuery";
import DraftQuery from "./draftQuery";
import { useLocation, useNavigate } from "react-router-dom";
import { ROUTES, TOKENS } from "../../utilities/Constants/Constants";
import { getActionsHighlightPosition } from "../../utilities/utils";
import { ActionItemProps } from "../../utilities/types/DashboardTypes";
import { clearCheckedList, setSelectedAction } from "../../service/apiSlices/staticApi";
import { showSuccessToast } from "../../utilities/toastUtils";
import { useDeleteEmbeddingModelMutation } from "../../service/apiSlices/sematicModel";
import useDebounce from "../../hooks/useDebounce";
import DeleteConfirmModel from "../DeleteConfirModel/DeleteConfirmModel";

const modelsType = [
    { key: "generated", title: 'Generated List' },
    // { key: "navigatedb", title: 'Create New' },
    { key: "drafts", title: 'Drafts List' },
    { key: "navigateWorkbentch", title: 'Create Model' },
];

const QueryListCard = () => {
    const [activeTab, setActiveTab] = useState("generated");
    const { t } = useTranslation("common");
    const [searchValue, setSearchValue] = useState("");
    const [isActive, setIsActive] = useState(false);
    const location = useLocation();

    const returnPath = location?.state?.returnPath;
    const dispatch = useDispatch();
    const [deleteModel] = useDeleteEmbeddingModelMutation()
    const connection_Id = sessionStorage.getItem(TOKENS.CONNECTION_ID);
    const { selectedAction, checkedList, listofDisplayItems } = useSelector((state: any) => state.static)


    const [activeView, setActiveView] = useState('Data Explorer');

    const { activeCard } = useSelector((state: any) => state.static)

    const [hoveredView, setHoveredView] = useState<any>(null);
    const [actionsActive, setActionsActive] = useState<any>(null);
    const [actionsHovered, setActionsHovered] = useState<any>(null);
    const [hoveredFilter, setHoveredFilter] = useState<any>(null);
    const debouncedSearchText = useDebounce(searchValue);
    const [value, setValue] = useState('1');
    type Align = 'All' | 'Last Created' | 'Recently opened';
    const [alignQuery, setAlignQuery] = useState<Align>("All");
    const navigate = useNavigate()
    const [perpage, setPerpage] = useState(24)
    const [deleteModalOpen, setDeleteModalOpen] = useState<{ state: boolean; Databasename: string[] }>({
        state: false,
        Databasename: [],
    });

    const isQueryTab = value === "1";

    useEffect(() => {
        dispatch(setSelectedAction(""));
    }, []);

    useEffect(() => {
        dispatch(clearCheckedList());
        dispatch(setSelectedAction("uncheck"))
        setIsActive(false);
    }, [activeView, activeTab])

    const handleCheckAction = () => {
        setIsActive((prev) => !prev);

        const selectedAction = !isActive ? "check" : "uncheck"
        dispatch(setSelectedAction(selectedAction));
        if (selectedAction === 'uncheck') dispatch(clearCheckedList())
    }

    const handleDeletelist = () => {
        let payload = { secret_key: checkedList.semantic };
        if (activeTab === "drafts") payload.secret_key = checkedList.draft_semantic;

        if (payload.secret_key.length > 0) {
            deleteModel(payload).unwrap().then((res: any) => {
                if (res.status_code === 200) {
                    setActionsActive(null)
                    setIsActive(false)
                    dispatch(setSelectedAction(null));
                    dispatch(clearCheckedList());
                    setDeleteModalOpen((prev) => ({
                        ...prev,
                        state: false,
                    }))
                    showSuccessToast(res.message);
                }
            })
                .catch((err: any) => { })
        }

        handleCheckAction()
    }

    const handleOnActionClick = (key: ActionItemProps["key"]) => {
        switch (key) {
            case "check":
                handleCheckAction();
                break;

            case "delete":
                // setIsActive((prev) => !prev);
                if (checkedList.draft_semantic.length > 0 || checkedList.semantic.length > 0 || checkedList.dataExplorer.length > 0 || checkedList.report.length > 0) {

                    const databaseSources = [
                        { key: "draft_semantic", value: checkedList.draft_semantic },
                        { key: "semantic", value: checkedList.semantic },
                        { key: "dataExplorer", value: checkedList.dataExplorer },
                        { key: "report", value: checkedList.report },
                    ];
                    const firstNonEmpty = databaseSources.find(source => source.value.length > 0);
                    if (firstNonEmpty) {
                        setDeleteModalOpen({
                            state: true,
                            Databasename: firstNonEmpty.value,
                        });
                    }
                }
                // handleDeletelist()
                break;

            default:
                break;
        }
    };


    const renderTabContent = useCallback((type: string) => {
        const isTabActive = type === activeTab;

        switch (type) {
            case "generated":
                return (
                    <GenerateQuery
                        type={type}
                        activeView={activeView}
                        debouncedSearchText={debouncedSearchText}
                        perpage={perpage}
                        alignQuery={alignQuery}
                        isQueryTab={isQueryTab}
                        isTabActive={isTabActive}
                    />
                );
            case "drafts":
                return (
                    <DraftQuery
                        activeView={activeView}
                        debouncedSearchText={debouncedSearchText}
                        perpage={perpage}
                        isTabActive={isTabActive}
                        alignQuery={alignQuery}
                    />
                );

            default:
                return <></>;
        }
    }, [activeView, alignQuery, debouncedSearchText, isQueryTab, perpage, activeTab]);
    const handleTabChange = (key: string) => {
        if (key === "navigateWorkbentch") {
            navigate(ROUTES.SEMANTIC_MODEL);
            sessionStorage.setItem(TOKENS.MODEL_COMPLETED, JSON.stringify(null))
        } else {
            setActiveTab(key);
        }
    };
    const tabs = useMemo(() => {
        const filteredModelsType = modelsType.filter((model) => {
            return !(
                (activeCard === 'db_dashboad' && ['navigateWorkbentch', 'drafts'].includes(model.key)) ||
                (activeCard === 'db_semanticmodel' && model.key === 'navigatedb')
            );
        });

        return filteredModelsType.map((model) => ({
            ...model,
            content: renderTabContent(activeTab),
            disabled: selectedAction === 'check' && model.key !== 'delete',
        }));
    }, [activeCard, selectedAction, renderTabContent, modelsType]);



    const handleSearchValue = (e: any) => {
        setSearchValue(e.target.value);
    };
    const handleDeleteDatabase = () => {
        handleDeletelist();

    }

    return (
        <div className="glassy-card-list models-card-list">
            <div className="row">
                <div className="col-md-12">
                    <QueryTab
                        activeTab={activeTab}
                        tabs={tabs}
                        onTabChange={handleTabChange}
                        titleActions={
                            <>
                                <div className="d-flex align-items-center justify-content-between gap-2 models-actions-wrapper-list">

                                    <div className="copilot-dbtitle-txt">Semantic Models</div>

                                    <div className="model-actions-wrapper-list"
                                        onMouseLeave={() => setActionsHovered(null)}
                                    >
                                        <div
                                            className="action-button-highlight"
                                            style={{
                                                transform: `translateX(${getActionsHighlightPosition(actionsHovered, actionsActive)}px)`,
                                                opacity: actionsHovered || actionsActive ? 1 : 0
                                            }}
                                        />

                                    </div>

                                    <div className="">
                                        <Input
                                            placeholder="Search lists"
                                            variant="borderless"
                                            className="dashboard-search-model-input-li"
                                            prefix={<img src={search} alt="search" width={15} />}
                                            value={searchValue}
                                            onChange={handleSearchValue}
                                        />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="divider me-2"></div>
                                    </div>
                                </div>

                                <hr className="hrStyle-copilot me-3" />
                                <div className="d-flex align-items-center justify-content-between gap-3 mt-2">
                                    <Segmented
                                        className="custom-dataExploreSeg"
                                        options={['All', 'Last Created', 'Recently opened']}
                                        value={alignQuery}
                                        onChange={(val: any) => {
                                            setAlignQuery(val);
                                            dispatch(setSelectedAction('uncheck'));
                                            setIsActive(false);
                                        }}
                                        onMouseLeave={() => setHoveredFilter(null)}
                                        disabled={selectedAction === 'check'}
                                        block
                                    />
                                    <div className="d-flex gap-2">
                                        <div className="select-all-button-wrapper-list">
                                            <button className={`select-all-button-list ${isActive ? "active" : ""}`} onClick={() => handleOnActionClick('check')}
                                                disabled={listofDisplayItems === 0} style={{
                                                    cursor: listofDisplayItems === 0 ? "not-allowed" : "pointer"
                                                }}>
                                                <img src={selectIcon} alt="select" />
                                                <span>{isActive ? "DeSelect" : "Select"}</span>
                                            </button>
                                        </div>
                                        <div className="model-actions-wrapper-list me-3"
                                            onMouseLeave={() => setActionsHovered(null)}
                                        >
                                            <div
                                                className="action-button-highlight"
                                                style={{
                                                    transform: `translateX(${getActionsHighlightPosition(actionsHovered, actionsActive)}px)`,
                                                    opacity: actionsHovered || actionsActive ? 1 : 0
                                                }}
                                            />

                                            <div className="delete-button-wrapper-list">
                                                <button className={`delete-button-list ${isActive ? 'active' : ''}`}
                                                    // setActionsActive('delete');
                                                    // onMouseEnter={() => setActionsHovered('delete')}
                                                    onClick={() => { handleOnActionClick('delete') }}
                                                    disabled={listofDisplayItems === 0} style={{
                                                        cursor: listofDisplayItems === 0 ? "not-allowed" : "pointer"
                                                    }}
                                                >
                                                    <img src={deleteIcon} width={20} alt="delete" />
                                                    Delete
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </>
                        }
                    />
                </div>
            </div>
            <DeleteConfirmModel
                visible={deleteModalOpen}
                onCancel={() =>
                    setDeleteModalOpen((prev) => ({
                        ...prev,
                        state: false,
                    }))
                }
                title={t("reportdeletemodal.title")}
                onConfirm={handleDeleteDatabase}
                cancelText="Cancel"
                okText="Confirm"
                content={t("reportdeletemodal.description")}
                count={deleteModalOpen?.Databasename?.length}
            />
        </div>
    );
};

export default QueryListCard;

